/**
 * Direct selector to the app state domain
 */
const selectPopupDomain = () => (state) => state.popup;

export { selectPopupDomain };
